import SigliveServiceV1 from 'Service/sigliveServiceV1';

const postClockInHost = async (payload) => {
  const { data } = await SigliveServiceV1({
    method: 'POST',
    url: `/monitoring-host/presences/clock-in`,
    data: payload,
  });

  return data?.data;
};

export default postClockInHost;
